module.exports = __webpack_public_path__ + "img/1.f5851bd4.png";